
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
    formations: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      selectedFormations: {
        teamA: `433`,
        teamB: `4231`,
      },
      mobileTooltips: {
        left: false,
        right: false,
      },
    };
  },
  computed: {
    teams () {
      return [
        this.getTeam(this.fixture),
        this.getTeam(this.fixture, `Away`),
      ];
    },
  },
  methods: {
    getFormation (index) {
      // DEBUG: Pass correct selected formation
      return index === 0 ? this.selectedFormations.teamA : this.selectedFormations.teamB;
    },
  },
};
